import { generateApiClient } from '@guiker/rest-client'

import { AuthenticatedApi, JwtAuthenticatedApi } from '../api-definition'

export const AuthenticatedApiClient = generateApiClient('lease-api', AuthenticatedApi.routes)
export const JwtAuthenticatedApiClient = generateApiClient('lease-api', JwtAuthenticatedApi.routes)
